<template>
  <div class="resumeContainer">
    <!--    <div v-if="!isMb">-->
    <div>
      <el-row class="query-box" style="margin-bottom: 10px">
        <el-col
          :lg="{ span: 10, offset: 6 }"
          :md="8"
          :sm="24"
          :xs="24"
          style="margin-top: 10px"
        >
          <el-row
            type="flex"
            justify="space-around"
            :gutter="10"
            style="margin-left: 5px; margin-bottom: 5px"
          >
            <el-col :span="7">
              姓名
              <el-input
                v-model.trim="queryForm.name"
                style="width: 100px"
                placeholder="姓名"
                clearable
              >
              </el-input>
            </el-col>
            <el-col :span="7">
              手机
              <el-input
                v-model.trim="queryForm.mobile"
                style="width: 100px"
                placeholder="手机"
                clearable
              >
              </el-input>
            </el-col>
            <el-col :span="7">
              身份证号
              <el-input
                v-model.trim="queryForm.idCard"
                style="width: 100px"
                placeholder="身份证号"
                clearable
              >
              </el-input>
            </el-col>
            <el-col :span="3">
              <el-button
                icon="el-icon-search"
                type="primary"
                @click="queryData"
              >
                <span class="hidden-sm-and-down">查询</span>
              </el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <zr-page-table
        ref="pageTable"
        class="page-box"
        :loading-show="listLoading"
        :data="list"
        :row-class-name="tableRowClassName"
        :page-sizes="pageSizes"
        :columns="realCols"
        :total="total"
        :page-index="pageIndex"
        enabled-selection
        @refresh-page="fetchPageData"
      >
        <template v-slot:name="{ row }">
          <el-link>{{ row.name }}</el-link>
        </template>
      </zr-page-table>
    </div>
    <!--    手机版--------------------------------------------------------->
    <!--    <div v-else>-->
    <!--      <el-row v-for="post in list" :key="post.id" class="postInfo" :gutter="10">-->
    <!--        <el-col-->
    <!--            style="margin-left: 10px"-->
    <!--            :class="post.isRead == 0 ? 'postInfo1' : 'postInfo2'"-->
    <!--        >-->
    <!--          <el-row class="p-first"-->
    <!--          ><el-link-->
    <!--              :underline="false"-->
    <!--              type="primary"-->
    <!--              class="content-break"-->
    <!--              @click="viewResume(post.id, post.phase, post.university)"-->
    <!--          ><span class="index"> {{ post.index + "." }}</span>-->
    <!--            <span class="name"> {{ post.name }}</span></el-link-->
    <!--          ></el-row>-->
    <!--        </el-col>-->
    <!--      </el-row>-->
    <!--      <el-pagination-->
    <!--          ref="elPage"-->
    <!--          background-->
    <!--          :page-sizes="pageSizes"-->
    <!--          :page-size="pageSize"-->
    <!--          :current-page="pageIndex"-->
    <!--          layout="total, sizes, prev, pager, next, jumper"-->
    <!--          :total="total"-->
    <!--          style="float: right; padding-right: 5px; margin-bottom: 15px"-->
    <!--          @current-change="currentPageChange"-->
    <!--          @size-change="pageSizeChange"-->
    <!--      ></el-pagination>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { defaultPageSizes } from "@/config/settings";
import { getResumeInfoPage } from "@api/recruit/hr/resumeManagement";
var nowYear = new Date().getFullYear();
import { mapGetters } from "vuex";
import { isArray } from "zr-util/src/utils/comm/validate";
import isMobile from "@/utils/device";
const isMb = isMobile();

let def_pageSize = defaultPageSizes[0];
let def_pageIndex = 1;
let query = undefined;

export default {
  name: "UserManagement",
  components: {},
  // components: { ResumeList },
  data() {
    return {
      isMb: isMb,
      curPositionInfo: {},
      showTable: true,
      popVisible: false,
      positionInfoId: "",
      eduTypeArray: [],
      scienceArray: [],
      query: {},
      queryForm: {
        name: "",
        mobile: "",
        idCard: "",
      },
      statisticData: {
        collectCount: 0,
        resumeInfoCount: 0,
        unSuitCount: 0,
      },
      filterProps: {},
      list: [],
      listLoading: true,
      pageInfo: { pageIndex: def_pageIndex, pageSize: def_pageSize },
      total: 0,
      pageIndex: 1,
      pageSizes: defaultPageSizes,
      pageSize: defaultPageSizes[0],
      basicDatas: [],
      cltStartDate: undefined,
      cltEndDate: undefined,
      columns: [
        { code: "index", name: "序号", width: "50px" },
        { code: "name", name: "姓名", needDrawCell: true, width: "150px" },
        {
          code: "sex",
          name: "性别",
          formatter: (row, value) => {
            if (value == "female") {
              return "女";
            } else {
              return "男";
            }
          },
          width: 80,
        },
        {
          code: "age",
          name: "年龄",
          width: 80,
        },
        {
          code: "married",
          name: "婚否",
          formatter: (row, value) => {
            if (value == "1") {
              return "已婚";
            } else if (value == "2") {
              return "初婚";
            } else if (value == "3") {
              return "再婚";
            } else if (value == "4") {
              return "复婚";
            } else if (value == "5") {
              return "丧偶";
            } else if (value == "6") {
              return "离婚";
            } else {
              return "未婚";
            }
          },
          width: 100,
        },
        {
          code: "politicallyState",
          name: "政治面貌",
          formatter: (row, value) => {
            // if (value == "partyMember") {
            //   return "党员";
            // } else {
            //   return "群众";
            // }
            if (value === "partyMember") {
              return "中共党员";
            } else if (value === "中共预备党员") {
              return "中共预备党员";
            } else if (value === "共青团员") {
              return "共青团员";
            } else if (value === "民革会员") {
              return "民革会员";
            } else if (value === "民盟盟员") {
              return "民盟盟员";
            } else if (value === "民建会员") {
              return "民建会员";
            } else if (value === "民进会员") {
              return "民进会员";
            } else if (value === "农工党党员") {
              return "农工党党员";
            } else if (value === "致公党党员") {
              return "致公党党员";
            } else if (value === "九三学社社员") {
              return "九三学社社员";
            } else if (value === "台盟盟员") {
              return "台盟盟员";
            } else if (value === "无党派民主人士") {
              return "无党派民主人士";
            } else if (value === "其他") {
              return "其他";
            } else {
              return "群众";
            }
          },
          width: 100,
        },
        { code: "mobile", name: "手机", width: "200px" },
        { code: "birthdayLocal", name: "出生地", width: "200px" },
        { code: "cardNumber", name: "身份证号", width: "300px" },
        { code: "email", name: "邮箱", width: "300px" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      curRole: "user/curRole",
      userCode: "user/userCode",
      deptCode: "user/deptCode",
    }),
    showButtons() {
      return this.curRole == "admin";
    },
    realCols() {
      return this.showButtons ? this.columns : this.columns.slice(0, 11);
    },
  },
  watch: {
    $route: {
      handler(route) {
        this.positionInfoId = (route.query && route.query.positionInfoId) || "";
      },
      immediate: true,
    },
  },
  async created() {
    let size = def_pageSize;
    let index = def_pageIndex;
    if (query) {
      if (query.queryForm) {
        this.queryForm = query.queryForm;
      }
      if (query.pageSize) {
        size = query.pageSize;
      }
      if (query.pageIndex) {
        index = query.pageIndex;
      }
    }
    await this.fetchPageData({
      pageSize: parseInt(size),
      pageIndex: parseInt(index),
    });
  },
  beforeRouteEnter(to, from, next) {
    const preName = from.name;
    query = undefined;
    if (preName == "PersonalResumeView") {
      query = from.query;
    }
    next();
  },
  mounted() {},
  methods: {
    // 表格行渲染
    tableRowClassName({ row, rowIndex }) {
      if (row.isRead == 0 || row.isRead == "0") {
        return "gray-row";
      }
    },
    async currentPageChange(val) {
      this.pageIndex = val;
      this.pageInfo.pageIndex = this.pageIndex;
      await this.fetchPageData(this.pageInfo);
    },
    async pageSizeChange(val) {
      this.pageIndex = 1;
      this.pageSize = val;
      this.pageInfo.pageSize = this.pageSize;
      await this.fetchPageData(this.pageInfo);
    },
    async queryData() {
      await this.fetchPageData({
        pageSize: defaultPageSizes[0],
        pageIndex: 1,
      });
    },
    async fetchPageData(pageInfo) {
      this.showTable = false;
      this.pageIndex = pageInfo.pageIndex;
      pageInfo.deptCode = this.deptCode;
      pageInfo.action = this.activeName;
      this.listLoading = true;
      pageInfo.filterProps = this.filterProps;
      this.pageInfo = pageInfo;
      const res = await getResumeInfoPage({
        ...pageInfo,
        ...this.queryForm,
        postInfoId: this.positionInfoId,
      });
      if (res.success) {
        let data = res.data;
        this.listLoading = false;
        this.list = data.data;
        this.list = this.list.map((value) => {
          var age;
          if (value.birthday && value.birthday.length > 4) {
            var birthday = value.birthday.substring(0, 4);
            //计算年龄
            age = nowYear - parseInt(birthday);
          }
          value.age = age;
          return value;
        });
        this.total = data.total;
        this.$nextTick(() => {
          if (this.$refs.pageTable) {
            this.$refs.pageTable.clearSelection();
          }
        });
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
      setTimeout(() => {
        this.listLoading = false;
      }, 300);
      this.$nextTick(() => {
        this.showTable = true;
      });
    },

    // viewResume(id, phase, university) {
    //   this.$router.push({
    //     path: "/personalResumeView/index",
    //     query: {
    //       postSendId: id,
    //       phase: phase,
    //       university: university,
    //       ...this.pageInfo,
    //       activeName: this.activeName,
    //       queryForm: this.queryForm,
    //     },
    //   });
    // },
    scienceValFormat(value) {
      let jsonData = [];
      if (!value) {
        return value;
      }
      try {
        jsonData = JSON.parse(value);
      } catch (error) {
        if (value.indexOf(",") > 0) {
          jsonData = value.split(",");
        } else {
          jsonData = value;
        }
      }

      if (isArray(jsonData)) {
        const result = jsonData.map((data) => {
          const res = this.scienceArray.filter((val) => val.code == data);
          if (res && res.length > 0) {
            return res.map((value1) => value1.name).join(",");
          } else {
            return data;
          }
        });
        if (result && result.length > 0) {
          return result.join(",");
        }
      } else if (typeof jsonData == "string") {
        const result = this.scienceArray.filter((val) => val.code == jsonData);
        if (result && result.length > 0) {
          return result.map((value1) => value1.name).join(",");
        }
      }
      return jsonData;
    },
    eduRequireFormat(value) {
      const result = this.eduTypeArray.filter((val) => val.code == value);
      return result[0] ? result[0].name : value;
    },
    dateFormat(value) {
      if (value && typeof value == "string") {
        return value.substr(0, 10);
      } else {
        return value;
      }
    },
    sexFormat(value) {
      if (value == "female") {
        return "女";
      } else {
        return "男";
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "public/static/scss/commTableLayouts";
.item {
  margin-top: 10px;
  margin-right: 40px;
}
.page-box {
  margin-top: 5px;
  height: calc(#{$base-app-main-height} - 10px);
}
.tagActive {
  background-color: #44aaee;
  color: whitesmoke;
}
.tagsBox {
  margin-top: 20px;
  margin-left: 10px;
  span {
    cursor: pointer;
  }
}
.waiting {
  color: $base-font-color;
}
.pass {
  color: $base-color-green;
}
.notPass {
  color: $base-color-red;
}
.primarySelect {
  color: $base-color-blue;
}

.postInfo {
  mini-height: 80px;
  table-layout: fixed;
  position: relative;
  overflow: hidden;
  flex: 1;
  width: 100%;
  max-width: 100%;
  font-size: 12px;
  color: #606266;

  .p-first,
  .p-second,
  .p-third {
    margin-top: 5px;
  }

  .science,
  .sex,
  .phase,
  .university,
  .eduRequire,
  .studyField,
  .age,
  .requireNum {
    margin-left: 5px;
  }
  .isRead {
    float: right;
  }
  .name {
    font-weight: bold;
  }

  .postCount,
  .viewCount {
    position: relative;
    height: 100%;
    text-align: center;
    font-size: 30px;
    //font-weight: bold;
    color: #44aaee;

    span {
      font-size: 12px;
      color: #44aaee;
    }
  }
}

//.postInfo:nth-child(odd) {
//  background-color: #fafafa;
//}
//
//.postInfo:nth-child(even) {
//  background-color: #ffffff;
//}

.postInfo1 {
  background-color: #f3f3f3;
  //background-color: #0196a7;
}

.postInfo2 {
  background-color: #ffffff;
}

@mixin row-line {
  content: " ";
  height: 1px;
  width: 100%;
  background-color: #ebeef5;
}

.postInfo:before {
  @include row-line;
}

.rowLine {
  @include row-line;
}

.p-first,
.p-second,
.p-third {
  margin-top: 5px;
}

>>> label.el-form-item__label {
  width: 300px;
}

::v-deep .el-card__body {
  padding: 10px 5px 5px 5px;
}
::v-deep .el-card__header {
  padding: 5px 20px;
}
::v-deep .gray-row {
  background: #f3f3f3;
  //cursor: not-allowed !important;
}
</style>
